module.exports = __webpack_public_path__ + "static/media/helix-tree.e6db51f2.jpg";